module.exports = __webpack_public_path__ + "img/collapse.b8a9f743.svg";